import formatEuro from './formatEuro'

/**
 * Formats an amount as a signed Dutch euro string: '+ € 2.500,00' for gains,
 * '− € 2.500,00' for costs (typographic minus, absolute value), and the plain
 * unsigned zero amount for 0/missing. Shared by every view that renders
 * maatschappelijke-waarde deltas.
 *
 * @param {number|null|undefined} value - Amount in euros (negative = cost)
 * @returns {string}
 */
const formatEuroSigned = (value) => {
    if (!value) return formatEuro(0)
    const sign = value > 0 ? '+ ' : '− '
    return `${sign}${formatEuro(Math.abs(value))}`
}

export default formatEuroSigned
